import './index.css'
import React from 'react';
import Autocomplete from '../common/Autocomplete';
import TagInput from '../common/TagInput';
import { TicketUpdateFormModel } from '../../models/ticket.model';

interface AffectationProps {
  handleSelection: () => void,
  ticketUpdateForm: TicketUpdateFormModel
}

const Affectation: React.FC<AffectationProps> = ({
  handleSelection,
  ticketUpdateForm
}) => {

  return (
    <React.Fragment>

      <div className='tkt-form-section'>
        <div className='tkt-form-section-title'>
          <p>Afectación</p>
        </div>

        <div className='tkt-form-section-item'>
          <Autocomplete
            label='Elemento'
            placeholder='Elemento'
            disabled
            options={[]}
            name='element'
            value={ticketUpdateForm.element}
            handleSelection={handleSelection}
            required
          />
        </div>

        <div className='tkt-form-section-item alarms'>
          <TagInput
            label='Alarmas'
            name='alarms'
            placeholder='12345'
            inputType='text'
            values={ticketUpdateForm.alarms}
            handleSelection={handleSelection}
            disabled
          />

        </div>

      </div>
    </React.Fragment >
  );
}

export default Affectation;
